<template>
    <div class="row" v-if="recent">
        <card
            icon="pe-7s-note"
            :headline="$t('instagram.past30days.headline')"
            :description="$t('instagram.past30days.description')"
        >
			<div class="metric-wrapper">
				<div class="meta-row">
					<div class="meta-title">
						<strong>{{
							$t("instagram.followers.title")
						}}</strong>
					</div>
					<div
						class="meta-content"
						v-html="
							$t('instagram.followers.text', {
								value: followers
							})
						"
					/>
				</div>
				<div class="meta-row">
					<div class="meta-title">
						<strong>Opslags Visninger</strong>
					</div>
					<div class="meta-content">
						Dit indhold på instagram (opslag, stories, reels) er blevet set <span class="g-dynamic-value" v-text="impressions" /> gange i den valgte periode, hvor <span class="g-dynamic-value" v-text="reach" />  unikke personer har set dit indhold.
					</div>
				</div>
			</div>
        </card>
    </div>
</template>

<style lang="scss" scoped>
.metric-wrapper {
	display: flex;
	flex-direction: column;
	gap: 14px;
}
</style>

<script>
import { mapGetters } from "vuex";

export default {
    name: "RecentData",

    computed: {
        ...mapGetters("instagram", {
            recent: "getRecent"
        }),

        followers() {
            return this.getTotalValue("follower_count");
        },

        reach() {
            return this.getTotalValue("reach");
        },

        impressions() {
            return this.getTotalValue("impressions");
        }
    },

    methods: {
        getCollection(name) {
            return this.recent.find(obj => {
                return obj.name === name;
            });
        },

        getTotalValue(name) {
            const collection = this.getCollection(name);

            return collection
                ? collection.values
                      .map(row => row.value)
                      .reduce((a, b) => a + b)
                : 0;
        }
    }
};
</script>

<style scoped></style>
